import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { ProductOverviewSection } from '../components/landing/ProductOverviewSection';
import { ComparisonSection } from '../components/landing/ComparisonSection';
import { TrustBarSection } from '../components/landing/TrustBarSection';

export function LandingPage() {
  return (
    <div className="flex-1 flex flex-col min-h-0">
      <HeroSection />
      <ProblemSection />
      <ProductOverviewSection />
      <ComparisonSection />
      <TrustBarSection />
    </div>
  );
}
